/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, useRoutes, RouteObject } from 'react-router-dom';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { getLandingPageRoute } from '@pages/LandingPage';
import { getPlaceholderPageRoute } from '@pages/Placeholder';
import { getVendingMachinePageRoute } from '@pages/VendingMachinePage';
import { getProductPageRoute } from '@/pages/ProductLandingPage';
import { getProfilePageRoute } from '@/pages/ProfilePage';
import { getOrganizationProfilePageRoute } from '@/pages/OrganizationProfile';
import { getAdminPageRoute } from '@/pages/AdminPage';
import { getProvisionalPageRoute } from '@/pages/ProvisionalPage';
import { getActualPageRoute } from '@/pages/ActualPage';
import { getArchivedPageRoute } from '@/pages/ArchivedPolicy';
import { getHoldersPageRoute } from '@/pages/HolderPage';
import { getActualDetailPageRoute } from '@/pages/ActualDetailPage';
import { getProvisionalDetailPageRoute } from '@/pages/ProvisionalDetailPage';
import { getHoldersDetailPageRoute } from '@/pages/HoldersDetailPage';
import ScrollToTop from './ScrollToTop';
import { useSMAppNavigator } from './machines/pageContent';
import { getPayoutPageRoute } from '@/pages/PayoutPage';
import { getAboutMePageRoute } from '@/pages/AboutMePage';
import { getAnalyticsPageRoute } from '@/pages/AnalyticsPage';
import { getPayoutListPageRoute } from '@/pages/PayoutListPage';
import { getPayoutDetailPageRoute } from '@/pages/PayoutDetailPage';
import { getSignInPageRoute } from '@/pages/SignIn';
import { getEventTrackingPageRoute } from '@/pages/EventTrackerPage';
import { getDeathEventPageRoute } from '@/pages/CreateDeathEventPage';
const _handleDropDownItemClick = (item: any) => {};

export const AppNavigator = (): JSX.Element => {
  const { appNavigatorSend, appNavigatorState, appNavigatorMachine } =
    useSMAppNavigator({});

  if (appNavigatorState?.matches('RENDER_PAGE')) {
    const {
      brandLogo,
      brandLogoLink,
      brandTitle,
      sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSection,
    } = { ...(appNavigatorState?.event?.data?.value || {}) };
    const props = {
      brandLogo,
      brandLogoLink,
      brandTitle,
      items: sidebarItems,
      routes,
      orgName,
      orgUrl,
      copyrightStartYear,
      whoami,
      userName,
      userImage,
      dropdownItems,
      footerSections: footerSection,
      onDropDownItemClick: _handleDropDownItemClick,
    };

    const getAllRoutes = (): RouteObject[] => {
      return [
        getLandingPageRoute(props),
        getPlaceholderPageRoute(props),
        getVendingMachinePageRoute(props),
        getProductPageRoute(props),
        getProfilePageRoute(props),
        getOrganizationProfilePageRoute(props),
        getAdminPageRoute(props),
        getProvisionalPageRoute(props),
        getActualPageRoute(props),
        getArchivedPageRoute(props),
        getHoldersPageRoute(props),
        getActualDetailPageRoute(props),
        getProvisionalDetailPageRoute(props),
        getHoldersDetailPageRoute(props),
        getAboutMePageRoute(props),
        getAnalyticsPageRoute(props),
        getPayoutPageRoute(props),
        getPayoutListPageRoute(props),
        getPayoutDetailPageRoute(props),
        getSignInPageRoute(props),
        getEventTrackingPageRoute(props),
        getDeathEventPageRoute(props)
      ];
    };

    const RouterConfig = () => {
      const routes = useRoutes(getAllRoutes());
      return routes;
    };
    return (
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div></div>}>
          <RouterConfig />
        </Suspense>
      </BrowserRouter>
    );
  }
  if (appNavigatorState?.matches('GET_PAGE_CONTENT')) {
    return <div />;
  }
  return <></>;
};
